<template>
  <ul v-if="listItems && listItems.length" class="list">
    <ListItem
      v-for="(item, index) in listItems"
      :key="index"
      :listItem="item"
    ></ListItem>
  </ul>
</template>

<script>
import ListItem from "./listitem.vue";

export default {
  name: "List",
  props: {
    listItems: Array,
  },
  components: {
    ListItem,
  },
};
</script>
